const PW_STRENGTH_CHECK = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,75}$/;
exports.PW_STRENGTH_CHECK = PW_STRENGTH_CHECK;

